module.exports = __webpack_public_path__ + "media/images/icons/email-ff26f3be9b81cd096240015580a97d69.svg";